import { API_BASE_URL, API_ENDPOINTS } from '../constants/config';

class UserService {
  async syncUser(token) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.USERS}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to sync user');
    }

    return response.json();
  }

  async fetchUserData(token) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.USER_ME}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }

    return response.json();
  }

  async updateUsername(token, username) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.USER_USERNAME}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to set username');
    }

    return response.json();
  }

  async checkUsernameAvailability(username) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.CHECK_USERNAME(username)}`);
    return response.json();
  }

  async uploadAvatar(token, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.USER_AVATAR}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to upload avatar');
    }

    return response.json();
  }
}

const userService = new UserService();
export default userService;